export default isSportEvent =>
  isSportEvent
    ? {
        matchPointConfig: {
          ocurrencesSource: null,
          ocurrencesSourceId: null,
          ocurrencesVisible: null,
        },
      }
    : {};
